import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import paths from './../config/paths.json'
import AutoCompeleteAddress from "./autoCompeleteAddress";
import AutoNew from "./autoNew";
import useEndpoints from "../api/useEndpoints";
import axios from "axios";
import Storages from "../helper/storages";
import Checkbox from "./checkBox";
import acceptRequestServiceModal from "../modals/acceptRequestServiceModal";
import toast from "./toast";
import errorHandler from "../api/errorHandler";
import { fixNumbers } from "../helper/stringHepler";
import { fa2En } from "../helper/numberHelper";
import DashboardContext from "../contexts/dashboardContext";
import { BsBookmarkStarFill } from 'react-icons/bs'
import { FaStar } from 'react-icons/fa'
import { AiFillStar } from 'react-icons/ai'
import AcceptRequestModal from "../modals/acceptRequestModal";
import ScrollContainer from 'react-indiana-drag-scroll'
import { stepClasses } from "@mui/material";
import AddOriginAddress from "../modals/addOriginAddress";

export default function NewRequest(props) {
    var initState = {
        description: "",
        bigTark: false,
        returnOrigin: false,
        odati: false,
        haveBasket: false,
        bulkyLoad: false,
        insurance: false,
        fromStore: false,
        isCreditPayment: true,
        phoneNumber: "",
        driverCode: "",
        packetTypes: Storages.getDefualtPacketType(),
        nameReciver: "",
        stopTime: "",
        address: null,
        destAddressType: ""
    };
    const aRef = useRef();


    var submit = useRef();
    var address = useRef();


    var endpoints = useEndpoints();
    var phoneNumberRef = useRef();
    var [state, setState] = useState(initState);
    var [showAcceptRequestModal, setShowAcceptRequestModal] = useState(false);
    var [prices, setPrices] = useState([]);
    var [packetTypes, setPacketTypes] = useState([]);
    var [vehicleTypes, setVehicleType] = useState([]);
    const navigate = useNavigate();

    const dContext = useContext(DashboardContext)

    const [addressOption, setAddressOptions] = useState([]);

    var updateList = () => {
        axios.get(endpoints.destAddress,
            {
                params:
                {
                    searchTerm: '',
                },
                headers:
                {
                    'x-auth-token': Storages.getUserToken()
                }
            }).then((res) => {
                setAddressOptions(res.data.result);
            }).catch((e) => {
                console.log(e)
            })
    }

    useEffect(() => {

        updateList()
    }, [])

    const handleEnter = (event) => {
        if (event.key.toLowerCase() == "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    };

    const handleEnterAddress = (event) => {
        if (event.key.toLowerCase() == "enter") {
            phoneNumberRef.current.focus();
            event.preventDefault();

        }
    };

    const handleEnterToSubmit = (event) => {
        if (event.key.toLowerCase() == "enter") {
            submit.current.focus();
        }
    };
    var [addrStr, setAddrStr] = useState()

    const handleOnChange = (e) => {
        try {
            var value = e.target.value;
            var name = e.target.name;
            if (name == "priceId") value = JSON.parse(value);
            if (name == "vehicleType") value = JSON.parse(value);

            if (name == "address") {
                value = value.code;
                console.log('gggggggggggggggggg', value, e.target.valueStr)
                calcPrice(e.target.valueStr, value)
                setAddrStr(e.target.valueStr)
            }
            if (name == "phoneNumber" && value.length > e.target.maxLength) {
                value = value.slice(0, this.maxLength);
            }
            setState((prevState) => ({
                ...prevState,
                [name]: fa2En(value),
            }));
        } catch (err) {
            console.log(err);
        }
    };

    var [price, setPrice] = useState()
    const calcPrice = (stName, stCode) => {
        axios
            .get(endpoints.calcPrice, {
                params: {
                    stCode: stCode
                },
                headers: {
                    "x-auth-token": Storages.getUserToken(),
                },
            })
            .then((res) => {
                price = res?.data?.result?.price
                setPrice('حدود کرایه تا ' + stName + ' ' + price + ' تومان')
            })
            .catch((e) => {
                console.log(e);
            });
    }
    const handleOnChangeAddress = (e) => {
        try {
            var value = e.target.value;
            var name = e.target.name;
            addressOption.map((item, index) => {
                if (item.DestName.search(value) != -1) {
                    setState((prevState) => ({
                        ...prevState,
                        address: item.stCode,
                    }));
                }
            })
            setShowAddFavorite(true)

            setState((prevState) => ({
                ...prevState,
                [name]: fa2En(value),
            }));


        } catch (err) {
            console.log(err);
        }
    };

    const handleOnChangeCheck = (e) => {
        console.log(e.target.value);
        try {
            var value = e.target.value;
            var name = e.target.name;
            if (value == "true") value = true;
            else value = false;
            setState((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        } catch (err) {
            console.log(err);
        }
    };

    var [haveLocation, setHaveLocation] = useState(false)

    useEffect(() => {
        getFavoriteAddress()
        axios
            .get(endpoints.prices, {
                headers: {
                    "x-auth-token": Storages.getUserToken(),
                },
            })
            .then((res) => {
                setPrices(res.data.result);
                setState((prevState) => ({
                    ...prevState,
                    priceId: res?.data?.result[0]?.priceId,
                }));
            })
            .catch((e) => {
                console.log(e);
            });


        axios
            .get(endpoints.packetTypes, {
                headers: {
                    "x-auth-token": Storages.getUserToken(),
                },
            })
            .then((res) => {
                setPacketTypes(res.data.result);
                setState((prevState) => ({
                    ...prevState,
                    packetType: res?.data?.result[0]?.ptId,
                }));
            })
            .catch((e) => {
                console.log(e);
            });



        axios
            .get(endpoints.getBasicInfo, {
                headers: {
                    "x-auth-token": Storages.getUserToken(),
                },
            })
            .then((res) => {
                console.log('hggggggggggggggg', res?.data)

                if (res?.data?.result?.havaLocation == 0) {

                    console.log('hggggggggggggggg3', res?.data)

                    setHaveLocation(true)
                } else {
                }
            })
            .catch((e) => {
                console.log('hggggggggggggggg', e)
            });

        axios.get(endpoints.vehicle, {
            headers: {
                "x-auth-token": Storages.getUserToken(),
            },
        }).then((res) => {
            setVehicleType(res.data.result);
            setState((prevState) => ({
                ...prevState,
                vehicleType: res?.data?.result[0]?.vId,
            }));
        }).catch((e) => {
            console.log(e);
        });
    }, []);

    var [favoriteList, setFavoriteList] = useState([])
    var getFavoriteAddress = () => {
        axios.get(endpoints.favoriteAddress, {
            headers: {
                "x-auth-token": Storages.getUserToken(),
            },
        })
            .then((res) => {
                setFavoriteList(res.data.result)

            })
            .catch((e) => {
                console.log(e);
            });
    }
    var [showAddFavorite, setShowAddFavorite] = useState(true)

    useEffect(() => {
        console.log('ssssssssssssss222222', dContext)
        setState(prevState => ({
            ...prevState,
            destAddressType: dContext.favAddress.destAddress,
            nameReciver: dContext.favAddress.destName,
            phoneNumber: dContext.favAddress.destMobile
        }))
        setShowAddFavorite(false)
        phoneNumberRef.current.focus()

    }, [])

    var sendRequestToServer = (flag, title) => {

        console.log(state)
        var destAddressType = state.destAddressType
        if (state.destAddressType == undefined || state?.destAddressType?.length == 0)
            destAddressType = addrStr


        if (state.destAddressType == undefined || state?.destAddressType?.length == 0) {
            toast.Error("لطفا ادرس را وارد نمایید")
            destAddressTypeRef?.current?.focus()
            return
        }

        var params = {
            ...state,
            titleName: title,
            addToFavorite: flag,
            destAddressType: destAddressType,
            description: state.description + (price ? " , " + price : '')
        }

        Storages.setDefualtPacketType(params?.packetType)
        axios
            .post(endpoints.insertService, params, {
                headers: {
                    "x-auth-token": Storages.getUserToken(),
                },
            })
            .then((res) => {
                toast.Success("با موفقیت ثبت شد");

                setState({
                    ...initState,
                    vehicleType: vehicleTypes[0]?.vId,

                })

                // window.location.reload();
                console.log(dContext.isMobile)
                if (dContext.isMobile) {
                    console.log(paths.history, dContext.isMobile)
                    navigate(paths.history)
                }
                setShowAddFavorite(true)

                props.refreshPage()
                getFavoriteAddress()
                address.current.focus();

            })
            .catch((e) => {
                console.log(e);
                errorHandler(e);
            });
    };

    var destAddressTypeRef = useRef()

    var onSendRequest = () => {
        // console.log('result',state)
        // acceptRequestServiceModal.show(sendRequestToServer);
        setShowAcceptRequestModal(true)

    };

    var onSendRequestByEnter = (e) => {
        if (e.key.toLowerCase() === "enter") {
            onSendRequest();
        }
    };

    return (
        <div className="">
            <div className="flex flex-column m-4  ">
                <form className=" row d-flex flex-column ">
                    <div className="row p-0 m-0 col-12   ">
                        <div className="col-12 m-0 p-0 ">
                            <div className=" m-1">
                                <h4>آدرس مقصد</h4>
                                <div className="row g-2">
                                    <div className="col-9 col-md-10 ">
                                        <h6 className="text-danger opacity-0">
                                            .
                                        </h6>
                                        <input

                                            ref={destAddressTypeRef}
                                            type="text"
                                            className="form-control inputReq"
                                            placeholder="آدرس گیرنده را اینجا وارد کنید"
                                            onKeyDown={handleEnterAddress}
                                            onChange={handleOnChangeAddress}
                                            name="destAddressType"
                                            value={state.destAddressType}
                                        />

                                    </div>
                                    <div className="col-12 col-md-6 d-none">

                                        <h6 className="text-danger ">
                                            .{price}
                                        </h6>
                                        <AutoCompeleteAddress
                                            onKeyDown={(event) => {
                                                if (event.key.toLowerCase() == "enter") {
                                                    phoneNumberRef.current.focus();
                                                    event.preventDefault();

                                                }
                                            }}
                                            onChange={handleOnChange}
                                            name="address"
                                            onClose={() => {
                                                setPrice(0)
                                            }}
                                            value={state.address}
                                            onType={(e) => {
                                                console.log(e)
                                            }}
                                        />

                                    </div>
                                    <div className="col-3 col-md-2">
                                        <h6 className="text-danger opacity-0">
                                            .
                                        </h6>
                                        <input

                                            type="number"
                                            className="form-control inputReq"
                                            placeholder="کد راننده"
                                            onKeyDown={handleEnterAddress}
                                            onChange={handleOnChangeAddress}
                                            name="driverCode"
                                            value={state.driverCode}
                                        />
                                    </div>
                                </div>

                            </div>
                            {/* <p>آدرس نوشته شده : {state?.address}</p> */}

                        </div>

                        <div className="col-12 m-0 p-0 d-flex  my-2" style={{ whiteSpace: 'nowrap' }}>

                            <div className=" m-0 p-0 mx-1 my-1 flex-none" >
                                <button className="btn btn-warning btn d-flex align-items-center"

                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(paths.favorite)

                                    }}>
                                    <FaStar size={23} />
                                </button>

                            </div>

                            {
                                favoriteList.length > 0 ?

                                    <ScrollContainer className="scroll-container">

                                        <div className="col-12 m-0 p-0 d-flex    " ref={aRef} style={{ whiteSpace: 'nowrap' }}>

                                            {
                                                favoriteList.map((item, index) => {
                                                    return (
                                                        <div className=" m-0 p-0 mx-1 my-1 flex-none" key={index}>
                                                            <button className="btn btn-primary btn d-flex align-items-center"
                                                                onClick={(e) => {
                                                                    e.preventDefault();

                                                                    setState(prevState => ({
                                                                        ...prevState,
                                                                        destAddressType: item.destAddress,
                                                                        nameReciver: item.destName,
                                                                        phoneNumber: item.destMobile
                                                                    }))
                                                                    setShowAddFavorite(false)

                                                                    phoneNumberRef.current.focus()
                                                                }}>
                                                                <BsBookmarkStarFill size={23} />
                                                                <h5 className="text-center m-auto mx-3 ">{item.showTitle}</h5>
                                                            </button>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </ScrollContainer>

                                    : <></>
                            }
                        </div>
                        <div className="col-6 col-sm-3   m-0 p-0 ">
                            <div className=" m-1">
                                <h4>نام گیرنده</h4>
                                <input
                                    type="text"
                                    className="form-control inputReq"
                                    placeholder="نام گیرنده را اینجا وارد کنید"
                                    onKeyDown={handleEnter}
                                    onChange={handleOnChange}
                                    name="nameReciver"
                                    value={state.nameReciver}
                                />
                            </div>
                        </div>

                        <div className="col-6 col-lg-3  m-0 p-0">
                            <div className=" m-1">
                                <h4>نوع مرسوله</h4>

                                <select
                                    className="form-select form-select-lg mb-3 inputReq pe-5 "
                                    aria-label=".form-select-lg example"
                                    onChange={handleOnChange}
                                    onKeyDown={handleEnterToSubmit}
                                    name="packetType"
                                >
                                    {packetTypes.map((item, index) => {
                                        return (
                                            <option value={item?.ptId} key={index} selected={item?.ptId == Storages.getDefualtPacketType()}>
                                                {item?.ptName}
                                            </option>
                                        );

                                    })}
                                </select>
                            </div>
                        </div>
                        <div className=" col-6 col-lg-3 m-0 p-0 ">
                            <div className=" m-1">
                                <h4>همراه گیرنده</h4>
                                <input
                                    ref={phoneNumberRef}
                                    type="number"
                                    className="form-control inputReq"
                                    placeholder="شماره گیرنده را اینجا وارد کنید"
                                    onKeyDown={handleEnter}
                                    maxLength="11"
                                    onChange={handleOnChange}
                                    name="phoneNumber"
                                    value={state.phoneNumber}
                                />
                            </div>
                        </div>



                        <div className="col-6 col-lg-3  m-0 p-0">
                            <div className=" m-1">
                                <h4>نوع وسیله</h4>

                                <select
                                    className="form-select form-select-lg mb-3 inputReq pe-5 "
                                    aria-label=".form-select-lg example"
                                    onChange={handleOnChange}
                                    onKeyDown={handleEnterToSubmit}
                                    name="vehicleType"
                                >
                                    {vehicleTypes.map((item, index) => {
                                        if (index == 0 && state.vId == null)
                                            return (
                                                <option value={item.vId} key={index} selected>
                                                    {item.vName}
                                                </option>
                                            );
                                        else
                                            return (
                                                <option value={item.vId} key={index}>
                                                    {item.vName}
                                                </option>
                                            );
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="col-6 col-lg-3  m-0 p-0">
                            <div className=" m-1">
                                <h4>ارزش کالا</h4>

                                <select
                                    className="form-select form-select-lg mb-3 inputReq pe-5 "
                                    aria-label=".form-select-lg example"
                                    onChange={handleOnChange}
                                    onKeyDown={handleEnterToSubmit}
                                    name="priceId"
                                >
                                    {prices.map((item, index) => {
                                        if (index == 0 && state.priceId == null)
                                            return (
                                                <option value={item.priceId} key={index} selected>
                                                    {item.priceDesc}
                                                </option>
                                            );
                                        else
                                            return (
                                                <option value={item.priceId} key={index}>
                                                    {item.priceDesc}
                                                </option>
                                            );
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="col-6 col-lg-3 m-0 p-0 ">
                            <div className=" m-1 ">
                                <div className="d-flex flex-row align-items-center">
                                    <h4 className="ps-2">توقف</h4>
                                    <h6>(دقیقه)</h6>
                                </div>
                                <input
                                    type="number"
                                    className="form-control inputReq"
                                    placeholder="به دقیقه"
                                    onKeyDown={handleEnter}
                                    name="stopTime"
                                    pattern="[1-9]"
                                    value={state.stopTime}
                                    onChange={handleOnChange}
                                />
                            </div>
                        </div>

                        <div className="col-12 col-lg-6 m-0 p-0">
                            <div className="m-1">
                                <h4>پرداخت کننده</h4>
                                <div className="card pt-3  rounded">
                                    <div className="row align-item-center justify-content-center">
                                        <div className="form-check justify-content-center align-item-center form-switch col-5 switchBtn">
                                            <label
                                                className="form-check-label w-100"
                                                htmlFor="credit"
                                            >
                                                {" "}
                                                فرستنده
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="isCreditPayment"
                                                value={false}
                                                id="credit"
                                                onKeyDown={handleEnter}
                                                onChange={handleOnChangeCheck}
                                                checked={!state.isCreditPayment}
                                            />
                                        </div>
                                        <div className="form-check form-switch col-5   switchBtn">
                                            <label className="form-check-label w-100" htmlFor="cash">
                                                گیرنده{" "}
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="isCreditPayment"
                                                value={true}
                                                id="cash"
                                                onKeyDown={handleEnterToSubmit}
                                                onChange={handleOnChangeCheck}
                                                checked={state.isCreditPayment}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row col-12 m-0 p-0  ">
                        <div className="col-12  col-lg-6 m-0 p-0 ">
                            <div className=" m-1">
                                <h4>توضیحات</h4>
                                <textarea
                                    className="form-control"
                                    id="exampleFormControlTextarea1"
                                    rows="5"
                                    placeholder="توضیحات را اینجا وارد کنید"
                                    onKeyDown={handleEnter}
                                    name="description"
                                    value={fixNumbers(state.description)}
                                    onChange={handleOnChange}
                                ></textarea>
                            </div>
                        </div>

                        <div className="col-12  col-lg-6 m-0 p-0">
                            <div className="m-1">
                                <h4>گزینه ها</h4>
                                <div className="card  m-0 p-0 flex-row rounded p-3">
                                    <div className="col-5">
                                        <Checkbox
                                            name="bigTark"
                                            title="ترک بزرگ"
                                            onChange={handleOnChangeCheck}
                                            onKeyDown={handleEnter}
                                            checked={state.bigTark}
                                        />
                                        <Checkbox
                                            name="returnOrigin"
                                            title="بازگشت به مبدا"
                                            onChange={handleOnChangeCheck}
                                            onKeyDown={handleEnter}
                                            checked={state.returnOrigin}
                                        />
                                        <Checkbox
                                            name="odati"
                                            title="عودتی"
                                            onChange={handleOnChangeCheck}
                                            onKeyDown={handleEnter}
                                            desc="(پول ، بارنامه و کارتخوان)"
                                            checked={state.odati}
                                        />
                                        {/* <Checkbox
                                            name="insurance"
                                            title="بیمه شود"
                                            onChange={handleOnChangeCheck}

                                            onKeyDown={handleEnter}
                                            checked={state.insurance}
                                        /> */}
                                    </div>
                                    <div className="col-6 m-0 me-3 ">
                                        <Checkbox
                                            name="haveBasket"
                                            title="صندوق داشته باشد"
                                            onChange={handleOnChangeCheck}
                                            onKeyDown={handleEnter}
                                            checked={state.haveBasket}
                                        />
                                        <Checkbox
                                            name="bulkyLoad"
                                            title="بارحجیم"
                                            onChange={handleOnChangeCheck}
                                            onKeyDown={handleEnter}
                                            checked={state.bulkyLoad}
                                        />
                                        <Checkbox
                                            name="fromStore"
                                            title="تحویل از انبار"
                                            onChange={handleOnChangeCheck}
                                            onKeyDown={handleEnter}
                                            checked={state.fromStore}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <button
                    className="btn btn-success  iranSansBold col-12 mb-3 mt-5 "
                    ref={submit}
                    style={{ height: "4rem" }}
                    onClick={onSendRequest}
                    onKeyDown={onSendRequestByEnter}
                >
                    <h4>ثبت سرویس</h4>
                </button>

                <button className="btn btn-success  iranSansBold col-12 mb-3 mt-5 invisible"></button>
            </div >

            <AcceptRequestModal
                show={showAcceptRequestModal}
                showAddFavorite={showAddFavorite}
                onClose={() => {
                    setShowAcceptRequestModal(false)
                }}
                onAccept={(flag, title) => {
                    setShowAcceptRequestModal(false)
                    sendRequestToServer(flag, title)
                }} />

            <AddOriginAddress
                onClose={() => {

                }}
                eshCode={Storages.getUserInfo().eshterakId}
                show={haveLocation}
                onResult={
                    (params) => {
                        axios.put(endpoints.address, params,
                            {
                                headers:
                                {
                                    'x-auth-token': Storages.getUserToken()
                                }
                            }).then((res) => {
                                Storages.setUserInfo({ ...Storages.getUserInfo(), ...params, address: params?.fullAddress })
                                toast.Success("آدرس با موفقیت تغییر یافت")
                            }).catch((e) => {
                                errorHandler(e)
                            })
                    }
                } />
        </div >
    );
}